import { initialSitesState, actions } from "./action";

export const sitesReducer = (state = initialSitesState, action) => {
    switch (action.type) {
        case actions.SITES_GET_ALL_SUCCESS:
            return {
                ...state,
                sitesList:  action.payload ? action.payload : {}
            };
        case actions.SITES_UPDATE_SUCCESS:
            return {
                ...state,
                siteDetails: action.payload?.id ? {...action.payload, action: 'update'} : {}
            };
        case actions.SITES_CREATE_SUCCESS:
            return {
                ...state,
                siteDetails: action.payload?.id ? {...action.payload, action: 'create'} : {}
            };
        case actions.SITES_DELETE_SUCCESS:
            return {
                ...state,
                siteDetails: action.payload?.id ? {...action.payload, action: 'delete'} : {}
            };
        case actions.SITES_RESET_SUCCESS:
            return {
                ...state,
                siteDetails: {}
            };
        default:
            return state;
    }
};
